// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';

export default function(state = {}, action) {
  const typeMap = {
    HOMEPAGE_FEATURE_TERM_LOADING() {
      return {
        isLoading: true,
        homepageFeatureTerm: action.homepageFeatureTerm
      };
    },
    HOMEPAGE_FEATURE_TERM_LOADED() {
      return {
        isLoading: false,
        posts: get(action, 'homepageFeatureTerm.posts'),
        name: get(action, 'homepageFeatureTerm.name'),
        slug: get(action, 'homepageFeatureTerm.slug')
      };
    },
    HOMEPAGE_FEATURE_TERM_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: get(action, 'homepageFeatureTerm.errorMessage')
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
